// NAKED · Mega menú: alinea la columna de enlaces bajo el ítem del menú que la abre.
// Escribe --naked-mega-x en cada panel de ancho completo; naked-nav.css la usa como margen izquierdo.
(() => {
  const nav = document.getElementById('t4s-nav-ul');
  if (!nav) return;

  const MIN_COLUMN = 320;

  const placePanel = (item) => {
    const link = item.querySelector(':scope > a');
    const panel = item.querySelector(':scope > .t4s-sub-menu');
    if (!link || !panel) return;

    const panelBox = panel.getBoundingClientRect();
    if (!panelBox.width) return;
    const panelStyle = getComputedStyle(panel);
    const contentLeft = panelBox.left + parseFloat(panelStyle.paddingLeft);
    const contentWidth = panelBox.width - parseFloat(panelStyle.paddingLeft) - parseFloat(panelStyle.paddingRight);
    const textLeft = link.getBoundingClientRect().left + parseFloat(getComputedStyle(link).paddingLeft);

    const x = Math.max(0, Math.min(textLeft - contentLeft, contentWidth - MIN_COLUMN));
    panel.style.setProperty('--naked-mega-x', `${Math.round(x)}px`);
  };

  const items = [...nav.querySelectorAll(':scope > li.t4s-type__mega.menu-width__full')];
  const placeAll = () => items.forEach(placePanel);

  // El encabezado fijo cambia de tamaño al hacer scroll, por eso se recalcula al entrar en cada ítem.
  items.forEach((item) => item.addEventListener('pointerenter', () => placePanel(item)));
  window.addEventListener('resize', placeAll);
  window.addEventListener('load', placeAll);
  if (document.fonts) document.fonts.ready.then(placeAll);
  placeAll();
})();
